import {
  APIgetFiles,
  APIupdateFile,
  APIdeleteFile,
  APIdeleteFiles,
  APIrestoreDeletedFile,
  APIgetFileStatuses,
  APIlikeFile,
  APIunlikeFile,
  APIgetFileComments,
  APIgetShareFileComments,
  APIcreateFileVersion,
  APIdeleteFileVersion,
  APIrestoreFileVersion,
  APIgetFilesGroup,
  APIgetFileEditions,
  APIgetFileVersionComments,
  APIcopyFileVersionComments,
  APIgetShareFileVersionComments,
  APIdeleteFilePermanent,
  APIdeleteFilesPermanent,
  APIrestoreDeletedFiles,
} from '../api/Files';
import {
  APIcreateDownload,
  APIgetDownloadDetails,
} from '../api/Downloads';
import { APIupdateFace } from '../api/Faces';

import {
  isArchive,
  isTrash,
  isFavorites,
  isMini,
} from '../helpers/App';
import { eventDispatch } from '../helpers/Events';
import { getFilesView } from '../helpers/Files';

import { setUserSetting } from './Auth';

export const SET_FILES_LOADING = 'SET_FILES_LOADING';
export const SET_FILES_END = 'SET_FILES_END';
export const GET_FILES = 'GET_FILES';
export const SET_FILES_TOTAL = 'SET_FILES_TOTAL';
export const SET_FILES_ARCHIVED = 'SET_FILES_ARCHIVED';
export const CLEAR_FILES = 'CLEAR_FILES';
export const CLEAR_FILES_LIST = 'CLEAR_FILES_LIST';
export const SET_FILES_PARAMS = 'SET_FILES_PARAMS';
export const CLEAR_FILES_PARAMS = 'CLEAR_FILES_PARAMS';
export const SET_FILES_FILTERS = 'SET_FILES_FILTERS';
export const SET_COLLECTION_UUID = 'SET_COLLECTION_UUID';
export const CLEAR_FILES_FILTERS = 'CLEAR_FILES_FILTERS';
export const SET_SELECTED_FILES = 'SET_SELECTED_FILES';
export const ADD_SELECTED_FILE = 'ADD_SELECTED_FILE';
export const ADD_SELECTED_FILES = 'ADD_SELECTED_FILES';
export const REMOVE_SELECTED_FILE = 'REMOVE_SELECTED_FILE';
export const CLEAR_SELECTED_FILES = 'CLEAR_SELECTED_FILES';
export const SET_SELECTED_ALL_FILES = 'SET_SELECTED_ALL_FILES';
export const SET_FILES_SEARCH_TYPE = 'SET_FILES_SEARCH_TYPE';
export const SHOW_UPLOAD_MODAL = 'SHOW_UPLOAD_MODAL';
export const HIDE_UPLOAD_MODAL = 'HIDE_UPLOAD_MODAL';
export const SET_UPLOAD_MODAL_MODE = 'SET_UPLOAD_MODAL_MODE';
export const SELECT_FILE = 'SELECT_FILE';
export const UPDATE_FILE_FRAGMENT = 'UPDATE_FILE_FRAGMENT';
export const ADD_FILE_TO_FILES_LIST = 'ADD_FILE_TO_FILES_LIST';
export const UPDATE_FILES_ON_FILES_LIST = 'UPDATE_FILES_ON_FILES_LIST';
export const UPDATE_FILES_LIKES_ON_FILES_LIST = 'UPDATE_FILES_LIKES_ON_FILES_LIST';
export const UPDATE_FILES_ON_SELECTED_FILES_LIST = 'UPDATE_FILES_ON_SELECTED_FILES_LIST';
export const REMOVE_FILES_FROM_FILES_LIST = 'REMOVE_FILES_FROM_FILES_LIST';
export const REMOVE_FILES_FROM_SELECTED_FILES_LIST = 'REMOVE_FILES_FROM_SELECTED_FILES_LIST';
export const UPDATE_LAST_FILES_UPDATE_TIME = 'UPDATE_LAST_FILES_UPDATE_TIME';
export const GET_AVAILABLE_FILTERS = 'GET_AVAILABLE_FILTERS';
export const GET_FILE_STATUSES = 'GET_FILE_STATUSES';
export const ADD_SELECTED_FILTER = 'ADD_SELECTED_FILTER';
export const SET_SELECTED_FILTERS = 'SET_SELECTED_FILTERS';
export const REMOVE_SELECTED_FILTER = 'REMOVE_SELECTED_FILTER';
export const CLEAR_SELECTED_FILTERS = 'CLEAR_SELECTED_FILTERS';
export const ADD_DOWNLOAD_REQUEST = 'ADD_DOWNLOAD_REQUEST';
export const REMOVE_DOWNLOAD_REQUEST = 'REMOVE_DOWNLOAD_REQUEST';
export const SWAP_FILES = 'SWAP_FILES';
export const SET_FILES_REORDERING_MODE = 'SET_FILES_REORDERING_MODE';
export const GET_FILE_COMMENTS = 'GET_FILE_COMMENTS';
export const SET_FILE_COMMENTS_LOADING = 'SET_FILE_COMMENTS_LOADING';
export const SET_FILE_COMMENTS_VIEW = 'SET_FILE_COMMENTS_VIEW';
export const SET_FILE_COMMENTS_ORDER = 'SET_FILE_COMMENTS_ORDER';
export const SET_FILE_COMMENT_HIGHLIGHTED = 'SET_FILE_COMMENT_HIGHLIGHTED';
export const SET_FILE_COMMENTS_ANNOTATE_MODE = 'SET_FILE_COMMENTS_ANNOTATE_MODE';
export const SET_FILE_SUBSCRIPTION = 'SET_FILE_SUBSCRIPTION';
export const SET_FILE_MODAL_OPEN = 'SET_FILE_MODAL_OPEN';
export const SET_FILES_GROUP_UUID = 'SET_FILES_GROUP_UUID';
export const SET_FILES_GROUP_LOADING = 'SET_FILES_GROUP_LOADING';
export const SET_FILE_EDITIONS = 'SET_FILE_EDITIONS';
export const SET_FILE_EDITIONS_LOADING = 'SET_FILE_EDITIONS_LOADING';
export const REMOVE_FILE_EDITION = 'REMOVE_FILE_EDITION';
export const GET_FILES_GROUP = 'GET_FILES_GROUP';
export const CLEAR_FILES_GROUP = 'CLEAR_FILES_GROUP';
export const SET_DOWNLOAD_UUID = 'SET_DOWNLOAD_UUID';
export const GET_DOWNLOAD = 'GET_DOWNLOAD';
export const CLEAR_DOWNLOAD = 'CLEAR_DOWNLOAD';
export const SET_DOWNLOAD_LOADING = 'SET_DOWNLOAD_LOADING';

export const setFilesLoading = status => ({
  type: SET_FILES_LOADING,
  loading: status,
});

export const setFilesEnd = status => ({
  type: SET_FILES_END,
  end: status,
});

export const getFiles = files => ({
  type: GET_FILES,
  files,
});

export const setFilesTotal = total => ({
  type: SET_FILES_TOTAL,
  total,
});

export const setFilesArchived = archived => ({
  type: SET_FILES_ARCHIVED,
  archived,
});

export const clearFiles = (hasSearch = false) => ({
  type: CLEAR_FILES,
  hasSearch,
});

export const clearFilesList = () => ({
  type: CLEAR_FILES_LIST,
});

export const setFilesParams = params => ({
  type: SET_FILES_PARAMS,
  params,
});

export const clearFilesParams = () => ({
  type: CLEAR_FILES_PARAMS,
});

export const setFilesFilters = filters => ({
  type: SET_FILES_FILTERS,
  filters,
});

export const clearFilesFilters = () => ({
  type: CLEAR_FILES_FILTERS,
});

export const setCollectionUuid = collectionUuid => ({
  type: SET_COLLECTION_UUID,
  collectionUuid,
});

export const setSelectedFiles = files => ({
  type: SET_SELECTED_FILES,
  files,
});

export const addSelectedFile = file => ({
  type: ADD_SELECTED_FILE,
  file,
  isMini: isMini(),
});

export const addSelectedFiles = files => ({
  type: ADD_SELECTED_FILES,
  files,
  isMini: isMini(),
});

export const removeSelectedFile = fileUuid => ({
  type: REMOVE_SELECTED_FILE,
  fileUuid,
});

export const clearSelectedFiles = () => ({
  type: CLEAR_SELECTED_FILES,
});

export const setSelectedAllFiles = allFilesSelected => ({
  type: SET_SELECTED_ALL_FILES,
  allFilesSelected,
});

export const setFilesSearchType = searchType => ({
  type: SET_FILES_SEARCH_TYPE,
  searchType,
});

export const showUploadModal = () => ({
  type: SHOW_UPLOAD_MODAL,
});

export const hideUploadModal = () => ({
  type: HIDE_UPLOAD_MODAL,
});

export const setUploadModalMode = mode => ({
  type: SET_UPLOAD_MODAL_MODE,
  mode,
});

export const setSelectedFile = file => ({
  type: SELECT_FILE,
  file,
});

export const unsetSelectedFile = () => ({
  type: SELECT_FILE,
  file: null,
});

export const updateFileFragment = fragment => ({
  type: UPDATE_FILE_FRAGMENT,
  fragment,
});

export const addFileToFilesList = (file, targetFileUuid) => ({
  type: ADD_FILE_TO_FILES_LIST,
  file,
  targetFileUuid,
});

export const updateFilesOnFilesList = (files) => ({
  type: UPDATE_FILES_ON_FILES_LIST,
  files,
});

export const updateFilesLikesOnFilesList = files => ({
  type: UPDATE_FILES_LIKES_ON_FILES_LIST,
  files,
});

export const updateFilesOnSelectedFilesList = files => ({
  type: UPDATE_FILES_ON_SELECTED_FILES_LIST,
  files,
});

export const removeFilesFromFilesList = files => ({
  type: REMOVE_FILES_FROM_FILES_LIST,
  files,
});

export const removeFilesFromSelectedFilesList = files => ({
  type: REMOVE_FILES_FROM_SELECTED_FILES_LIST,
  files,
});

export const updateLastFilesUpdateTime = () => ({
  type: UPDATE_LAST_FILES_UPDATE_TIME,
});

export const getAvailableFilters = filters => ({
  type: GET_AVAILABLE_FILTERS,
  filters,
});

export const getFileStatuses = statuses => ({
  type: GET_FILE_STATUSES,
  statuses,
});

export const addSelectedFilter = filter => ({
  type: ADD_SELECTED_FILTER,
  filter,
});

export const setSelectedFilters = filters => ({
  type: SET_SELECTED_FILTERS,
  filters,
});

export const removeSelectedFilter = (filterType, filterKey) => ({
  type: REMOVE_SELECTED_FILTER,
  filterType,
  filterKey,
});

export const clearSelectedFilters = () => ({
  type: CLEAR_SELECTED_FILTERS,
});

export const addDownloadRequest = downloadRequest => ({
  type: ADD_DOWNLOAD_REQUEST,
  downloadRequest,
});

export const removeDownloadRequest = downloadRequestUuid => ({
  type: REMOVE_DOWNLOAD_REQUEST,
  downloadRequestUuid,
});

export const swapFiles = (firstItem, secondItem) => ({
  type: SWAP_FILES,
  firstItem,
  secondItem,
});

export const setFilesReorderingMode = status => ({
  type: SET_FILES_REORDERING_MODE,
  status,
});

export const setFileCommentsLoading = loading => ({
  type: SET_FILE_COMMENTS_LOADING,
  loading,
});

export const getFileComments = comments => ({
  type: GET_FILE_COMMENTS,
  comments,
});

export const setFileCommentsView = view => ({
  type: SET_FILE_COMMENTS_VIEW,
  view,
});

export const setFileCommentsOrder = order => ({
  type: SET_FILE_COMMENTS_ORDER,
  order,
});

export const setFileCommentHighlighted = commentId => ({
  type: SET_FILE_COMMENT_HIGHLIGHTED,
  commentId,
});

export const setFileCommentsAnnotateMode = commentsAnnotateMode => ({
  type: SET_FILE_COMMENTS_ANNOTATE_MODE,
  commentsAnnotateMode,
});

export const setFileSubscription = status => ({
  type: SET_FILE_SUBSCRIPTION,
  status,
});

export const setFileModalOpen = status => ({
  type: SET_FILE_MODAL_OPEN,
  status,
});

export const setFilesGroupUuid = filesGroupUuid => ({
  type: SET_FILES_GROUP_UUID,
  filesGroupUuid,
});

export const setFilesGroupLoading = status => ({
  type: SET_FILES_GROUP_LOADING,
  loading: status,
});

export const setFileEditions = editions => ({
  type: SET_FILE_EDITIONS,
  editions,
});

export const setFileEditionsLoading = loading => ({
  type: SET_FILE_EDITIONS_LOADING,
  loading,
});

export const removeFileEdition = editionUuid => ({
  type: REMOVE_FILE_EDITION,
  editionUuid,
});

export const getFilesGroup = filesGroup => ({
  type: GET_FILES_GROUP,
  filesGroup,
});

export const clearFilesGroup = () => ({
  type: CLEAR_FILES_GROUP,
});

export const setDownloadUuid = downloadUuid => ({
  type: SET_DOWNLOAD_UUID,
  downloadUuid,
});

export const setDownloadLoading = loading => ({
  type: SET_DOWNLOAD_LOADING,
  loading,
});

export const getDownload = download => ({
  type: GET_DOWNLOAD,
  download,
});

export const clearDownload = () => ({
  type: CLEAR_DOWNLOAD,
});

export const fetchFiles = () => (dispatch, getState) => {
  dispatch(setFilesLoading(true));

  const state = getState();

  if (state.Files.end) {
    return false;
  }

  const params = { ...state.Files.params };
  const { selectedAllFiles } = state.Files;
  if (isArchive()) {
    params.archived = true;
  }
  if (isTrash()) {
    params.trashed = true;
  }
  if (isFavorites()) {
    params.favorites = true;
  }
  params.view = getFilesView();
  dispatch(setFilesArchived(0));

  let offset = 0;
  if (params.page * params.perPage > state.Files.files.length) {
    offset = state.Files.files.length;
  }
  params.per_page = params.perPage;
  delete params.perPage;

  params.search_type = state.Files.searchType;

  if ((!params.noFilters || params.noFilters === 'false' || params.noFilters === false) && params.page === 0) {
    APIgetFiles({
      collectionUuid: state.Files.collectionUuid,
      filesGroupUuid: state.Files.filesGroupUuid,
      downloadUuid: state.Files.downloadUuid,
      ...params,
      ...state.Files.filters,
      ...state.Search,
      only_filters: true,
    }).then((res) => {
      const { data: d } = res;
      dispatch(getAvailableFilters(d.data.filters));
      if (d.data.filters.selected_filters.length > 0) {
        dispatch(setFilesSearchType('latest'));
      }
    }).catch(error => (error));
  }

  params.page += 1;

  return APIgetFiles({
    collectionUuid: state.Files.collectionUuid,
    filesGroupUuid: state.Files.filesGroupUuid,
    downloadUuid: state.Files.downloadUuid,
    ...(offset > 0) && { offset },
    ...params,
    ...state.Files.filters,
    ...state.Search,
  })
    .then((response) => {
      const { data } = response;
      if (data && data.data) {
        dispatch(getFiles(data.data.data));
        dispatch(setSelectedFilters(data.data.filters.selected_filters));
        if (selectedAllFiles && data.data.data) {
          dispatch(addSelectedFiles(data.data.data));
          if (data.meta.total <= data.meta.to) {
            dispatch(setSelectedAllFiles(false));
          }
        }
        dispatch(setFilesLoading(false));
        if (data.meta.current_page >= data.meta.last_page) {
          dispatch(setFilesEnd(true));
        }
        dispatch(setFilesParams({ page: data.meta.current_page }));
        dispatch(setFilesTotal(data.meta.total));
        dispatch(setFilesArchived(data.data.files_archived || 0));
        if (data.data.latest_searches) {
          dispatch(setUserSetting({ latest_searches: data.data.latest_searches }));
        }
        return data;
      }
      return response;
    })
    .catch(error => (error));
};

export const updateFile = file => dispatch => (
  APIupdateFile(file)
    .then((response) => {
      if (response.data) {
        dispatch(updateFilesOnFilesList([response.data]));
        dispatch(updateFilesOnSelectedFilesList([response.data]));
        eventDispatch('fileUpdated', response.data);
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const fetchFileEditions = fileUuid => (dispatch) => {
  dispatch(setFileEditionsLoading(true));
  return APIgetFileEditions(fileUuid)
    .then((response) => {
      dispatch(setFileEditions(response.data));
      dispatch(setFileEditionsLoading(false));
      return response.data;
    });
};

export const deleteFile = (file, params = {}) => dispatch => (
  APIdeleteFile(file, params)
    .then((response) => {
      if (response.data) {
        dispatch(removeFilesFromFilesList([response.data]));
        dispatch(removeFilesFromSelectedFilesList([response.data]));
        eventDispatch('fileDeleted', response.data);
        dispatch(removeFileEdition(response.data.uuid));
        return response.data;
      }
      return response;
    })
);

export const deleteFiles = (params) => dispatch => (
  APIdeleteFiles(params)
    .then(response => {
      const { files } = params;
      dispatch(removeFilesFromFilesList(files.map(f => ({ uuid: f }))));
      dispatch(removeFilesFromSelectedFilesList(files.map(f => ({ uuid: f }))));
      files.forEach((file) => {
        eventDispatch('fileDeleted', { uuid: file });
      });
      return response.data;
    })
);

export const deleteFilePermanent = (file, params = {}) => dispatch => (
  APIdeleteFilePermanent(file, params)
    .then((response) => {
      if (response.data) {
        dispatch(removeFilesFromFilesList([response.data]));
        dispatch(removeFilesFromSelectedFilesList([response.data]));
        eventDispatch('fileDeleted', response.data);
        dispatch(removeFileEdition(response.data.uuid));
        return response.data;
      }
      return response;
    })
);

export const deleteFilesPermanent = (params) => dispatch => (
  APIdeleteFilesPermanent(params)
    .then(response => {
      const { files } = params;
      dispatch(removeFilesFromFilesList(files.map(f => ({ uuid: f }))));
      dispatch(removeFilesFromSelectedFilesList(files.map(f => ({ uuid: f }))));
      files.forEach((file) => {
        eventDispatch('fileDeleted', { uuid: file });
      });
      return response.data;
    })
);

export const restoreDeletedFile = (file, params = {}) => dispatch => (
  APIrestoreDeletedFile(file, params)
    .then((response) => {
      if (response.data) {
        dispatch(removeFilesFromFilesList([response.data]));
        dispatch(removeFilesFromSelectedFilesList([response.data]));
        dispatch(removeFileEdition(response.data.uuid));
        return response.data;
      }
      return response;
    })
);

export const restoreDeletedFiles = (params) => dispatch => (
  APIrestoreDeletedFiles(params)
    .then(response => {
      dispatch(removeFilesFromFilesList(params.files.map(f => ({ uuid: f }))));
      dispatch(removeFilesFromSelectedFilesList(params.files.map(f => ({ uuid: f }))));
      return response.data;
    })
);

export const refreshFiles = (orderby = null) => (dispatch) => {
  dispatch(clearFiles());
  if (orderby === 'position') {
    dispatch(setFilesParams({ orderby, order: 'asc' }));
  }
  dispatch(fetchFiles());
};

export const fetchFileStatuses = () => dispatch => (
  APIgetFileStatuses()
    .then((response) => {
      dispatch(getFileStatuses(response.data));
      return response.data;
    })
    .catch(error => (error))
);

export const clearFilesFiltersAndReload = (hasSearch = false) => (dispatch) => {
  dispatch(clearFilesFilters());
  dispatch(clearSelectedFilters());
  dispatch(clearFiles(hasSearch));
  dispatch(fetchFiles());
};

export const deleteSelectedFilter = (filterType, filterKey) => (dispatch, getState) => {
  const state = getState();
  const filters = { ...state.Files.filters };
  if (filters[filterType] && window._.isArray(filters[filterType])) {
    const newFilters = filters[filterType].filter(f => (`${f}` !== `${filterKey}`));
    dispatch(setFilesFilters({ [filterType]: newFilters }));
    dispatch(removeSelectedFilter(filterType, filterKey));
    dispatch(clearFilesList());
    dispatch(setFilesParams({ page: 0 }));
  } else if (filterType === 'search') {
    dispatch(removeSelectedFilter('search'));
    dispatch(clearFilesList());
    dispatch(setFilesParams({ page: 0 }));
  } else if (filterType === 'dates') {
    dispatch(setFilesFilters({
      date: null,
      date_from: null,
      date_to: null,
    }));
    dispatch(removeSelectedFilter('dates'));
    dispatch(clearFilesList());
    dispatch(setFilesParams({ page: 0 }));
  } else if (filterType === 'original_dates') {
    dispatch(setFilesFilters({
      original_date: null,
      original_date_from: null,
      original_date_to: null,
    }));
    dispatch(removeSelectedFilter('original_dates'));
    dispatch(clearFilesList());
    dispatch(setFilesParams({ page: 0 }));
  } else if (filterType === 'expiration_dates') {
    dispatch(setFilesFilters({
      expiration_date: null,
      expiration_date_from: null,
      expiration_date_to: null,
    }));
    dispatch(removeSelectedFilter('expiration_dates'));
    dispatch(clearFilesList());
    dispatch(setFilesParams({ page: 0 }));
  } else if (filterType === 'orientation') {
    dispatch(setFilesFilters({ [filterType]: null }));
    dispatch(removeSelectedFilter(filterType));
    dispatch(clearFilesList());
    dispatch(setFilesParams({ page: 0 }));
  }
};

export const createDownloadRequest = ({
  files,
  collections,
  fileSizes,
  fileFormats,
  versions,
  requestUuid = null,
}) => dispatch => (
  APIcreateDownload({
    files,
    collections,
    file_sizes: fileSizes,
    file_formats: fileFormats,
    request_uuid: requestUuid,
    versions,
  })
    .then((response) => {
      if (response.data && response.data.uuid && response.data.status !== 'empty') {
        dispatch(addDownloadRequest(response.data.uuid));
        return response.data;
      }
      return response.data;
    })
    .catch(error => (error))
);

export const fetchDownload = (downloadUuid) => dispatch => (
  APIgetDownloadDetails(downloadUuid)
    .then((response) => {
      dispatch(getDownload(response.data));
      return response.data;
    })
    .catch(error => (error))
);

export const likeFile = fileUuid => dispatch => (
  APIlikeFile(fileUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateFilesOnFilesList([response.data]));
        dispatch(updateFilesOnSelectedFilesList([response.data]));
        eventDispatch('fileUpdated', response.data);
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const unlikeFile = fileUuid => dispatch => (
  APIunlikeFile(fileUuid)
    .then((response) => {
      if (response.data) {
        dispatch(updateFilesOnFilesList([response.data]));
        dispatch(updateFilesOnSelectedFilesList([response.data]));
        eventDispatch('fileUpdated', response.data);
        return response.data;
      }
      return response;
    })
    .catch(error => (error))
);

export const switchFileLike = file => (dispatch) => {
  if (file.liked) {
    return dispatch(unlikeFile(file.uuid));
  }
  return dispatch(likeFile(file.uuid));
};

export const fetchFileComments = (fileUuid, silent = false) => (dispatch) => {
  if (!silent) {
    dispatch(setFileCommentsLoading(true));
    dispatch(getFileComments({ comments: [], subscribed: false }));
  }
  return APIgetFileComments(fileUuid)
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(getFileComments(data));
        if (!silent) {
          dispatch(setFileCommentsLoading(false));
        }
      }
      return data;
    })
    .catch(error => (error));
};

export const fetchShareFileComments = (shareUuid, fileUuid, silent = false) => (dispatch) => {
  if (!silent) {
    dispatch(setFileCommentsLoading(true));
    dispatch(getFileComments({ comments: [], subscribed: false }));
  }
  return APIgetShareFileComments(shareUuid, fileUuid)
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(getFileComments(data));
        if (!silent) {
          dispatch(setFileCommentsLoading(false));
        }
      }
      return data;
    })
    .catch(error => (error));
};

export const fetchFileVersionComments =
  (fileUuid, fileVersion, silent = false) => (dispatch) => {
    if (!silent) {
      dispatch(setFileCommentsLoading(true));
      dispatch(getFileComments({ comments: [], subscribed: false }));
    }
    return APIgetFileVersionComments(fileUuid, fileVersion)
      .then((response) => {
        const { data } = response;
        if (data) {
          dispatch(getFileComments(data));
          if (!silent) {
            dispatch(setFileCommentsLoading(false));
          }
        }
        return data;
      })
      .catch(error => (error));
  };

export const fetchShareFileVersionComments = (
  shareUuid,
  fileUuid,
  fileVersion,
  silent = false,
) => (dispatch) => {
  if (!silent) {
    dispatch(setFileCommentsLoading(true));
    dispatch(getFileComments({ comments: [], subscribed: false }));
  }

  return APIgetShareFileVersionComments(shareUuid, fileUuid, fileVersion)
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(getFileComments(data));
        if (!silent) {
          dispatch(setFileCommentsLoading(false));
        }
      }
      return data;
    })
    .catch(error => (error));
};

export const copyFileVersionComments = (fileUuid, fileVersion, params) => () => (
  APIcopyFileVersionComments(fileUuid, fileVersion, params)
    .then(response => (response))
    .catch(error => (error))
);

export const createFileVersion = (fileUuid, params) => dispatch => (
  APIcreateFileVersion(fileUuid, params)
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(updateFilesOnFilesList([data]));
      }
      return data;
    })
);

export const deleteFileVersion = (fileUuid, versionId) => dispatch => (
  APIdeleteFileVersion(fileUuid, versionId)
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(updateFilesOnFilesList([data]));
      }
      return data;
    })
);

export const restoreFileVersion = (fileUuid, versionId) => dispatch => (
  APIrestoreFileVersion(fileUuid, versionId)
    .then((response) => {
      const { data } = response;
      if (data) {
        dispatch(updateFilesOnFilesList([data]));
      }
      return data;
    })
);

export const fetchFilesGroup = filesGroupUuid => (dispatch) => {
  dispatch(setFilesGroupLoading(true));
  return APIgetFilesGroup(filesGroupUuid)
    .then((response) => {
      dispatch(getFilesGroup(response.data));
      dispatch(setFilesGroupLoading(false));
      return response.data;
    });
};

export const clearFacePerson = faceUuid => (
  APIupdateFace({ uuid: faceUuid, person_uuid: null })
    .then((response) => {
      eventDispatch('faceUpdated', response);
      return response.data;
    })
);
